import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Endpoint que recebe o redirect do backend /api/auth/magic.
 * - Le o JWT do URL fragment (#token=...)
 * - Limpa qualquer sessao anterior (prevencao de mistura entre contas)
 * - Salva o token, recarrega o user via /auth/me, redireciona pro destino
 */
export default function MagicRedirect() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState('');

  useEffect(() => {
    (async () => {
      try {
        // 1) Le token do fragment (nao vai pro servidor, mais seguro).
        //    Fallback: query param ?t= — o navegador do WhatsApp perde o
        //    #fragment em redirects entre dominios (www -> apex).
        const fragment = window.location.hash.replace(/^#/, '');
        const params = new URLSearchParams(fragment);
        const token = params.get('token') || searchParams.get('t');
        if (!token) {
          setError('Link invalido: token ausente.');
          return;
        }

        // 2) Limpa sessao anterior (NAO inclui onboarding_v1 — preferencia local persistente)
        const keys = ['token', 'dashboard_dark_mode', 'affiliate_token', 'affiliate_data', 'utm_params', 'fcod_utm'];
        keys.forEach(k => { try { localStorage.removeItem(k); } catch (_) { /* ignore */ } });
        try { sessionStorage.clear(); } catch (_) { /* ignore */ }
        try { delete axios.defaults.headers.common.Authorization; } catch (_) { /* ignore */ }

        // 3) Grava o novo token
        localStorage.setItem('token', token);

        // 4) Valida com /auth/me para garantir que o token e legitimo
        try {
          await axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } });
        } catch (e) {
          localStorage.removeItem('token');
          setError('Sessao invalida. Solicite um novo link no WhatsApp/e-mail mais recente.');
          return;
        }

        // 5) Limpa o fragment da URL (cosmetico) e navega pro destino
        const next = searchParams.get('next') || '/dashboard';
        // Hard navigation pra disparar o checkAuth do AuthContext com token novo
        window.location.replace(next);
      } catch (e) {
        setError('Erro ao processar o link. Tente novamente ou faca login normal.');
      }
    })();
  }, [navigate, searchParams]);

  if (error) {
    return (
      <div data-testid="magic-redirect-error" style={{minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', fontFamily: '-apple-system, sans-serif', padding: 20, background: '#0A2647', color: '#fff', textAlign: 'center'}}>
        <div style={{background: '#143057', borderRadius: 16, padding: 32, maxWidth: 400, width: '100%'}}>
          <div style={{fontSize: 32, marginBottom: 8}}>⚠️</div>
          <h2 style={{margin: '0 0 12px', fontSize: 20}}>Nao foi possivel entrar</h2>
          <p style={{color: '#cbd5e1', fontSize: 14, lineHeight: 1.5, margin: '0 0 24px'}}>{error}</p>
          <a href="/login" style={{display: 'inline-block', background: '#C5A059', color: '#0A2647', fontWeight: 'bold', padding: '12px 24px', borderRadius: 12, textDecoration: 'none', width: '100%', boxSizing: 'border-box'}}>Fazer login normal</a>
        </div>
      </div>
    );
  }

  return (
    <div data-testid="magic-redirect-loading" style={{minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', fontFamily: '-apple-system, sans-serif', background: '#0A2647', color: '#fff'}}>
      <div style={{textAlign: 'center'}}>
        <div style={{fontSize: 32, marginBottom: 12}}>⭐</div>
        <p style={{color: '#cbd5e1'}}>Entrando no seu painel...</p>
      </div>
    </div>
  );
}
